import mfes from './mfes.json';

type OriginsType = {
  SM: string;
  MW: string;
  KYC: string;
  BILLING: string;
  TGW: string;
  PRIVATE_LINK: string;
  TAGGING: string;
  DATABASE: string;
  DATABASE_ENDPOINTS: string;
  METRICS: string;
};

export type LocalService = keyof OriginsType;

export const ENVS = [
  { name: 'k8s-aa', value: 'app-sm.k8s-aa.sm-qa.qa', key: 'aa' },
  { name: 'k8s-billing-dev', value: 'app-sm.k8s-billing-dev.sm-qa.qa', key: 'bd' },
  { name: 'k8s-billing', value: 'app-sm.k8s-billing.sm-qa.qa', key: 'b' },
  { name: 'k8s-cloudapi', value: 'app-sm.k8s-cloudapi.sm-qa.qa', key: 'c' },
  { name: 'app-qa', value: 'app-qa.qa', key: 'q' },
  { name: 'k8s-db', value: 'app-sm.k8s-db.sm-qa.qa', key: 'db' },
  { name: 'k8s-dev', value: 'app-sm.k8s-dev.sm-qa.qa', key: 'd' },
  { name: 'app-gcp', value: 'app-gcp.qa', key: 'gc' },
  { name: 'k8s-gh', value: 'app-sm.k8s-gh.sm-qa.qa', key: 'g' },
  { name: 'k8s-idm', value: 'app-sm.k8s-idm.sm-qa.qa', key: 'i' },
  { name: 'k8s-rdi', value: 'app-sm.k8s-rdi.sm-qa.qa', key: 'rdi' },
  { name: 'k8s-integration', value: 'app-sm.k8s-integration.sm-qa.qa', key: 'in' },
  { name: 'k8s-mw', value: 'app-sm.k8s-mw.sm-qa.qa', key: 'm' },
  { name: 'k8s-psc', value: 'app-sm.k8s-psc.sm-qa.qa', key: 'ps' },
  { name: 'k8s-rcp', value: 'app-sm.k8s-rcp.sm-qa.qa', key: 'r' },
  { name: 'k8s-auto', value: 'app-sm.k8s-auto.sm-qa.qa', key: 'au' },
  { name: 'production', value: 'app', key: 'p' },
  { name: 'staging', value: 'app-staging.qa', key: 's' }
];

export const MFE_LIST = Object.entries(mfes).map(([name, cfg]) => ({
  name,
  port: cfg.port
}));

export const SERVICE_ORIGINS: { [key: string]: OriginsType } = {
  LOCAL_SM: {
    TAGGING: 'http://localhost:9090/tagging',
    SM: 'http://localhost:9090/api/v1',
    MW: 'http://localhost:9090/maintenance-window',
    KYC: 'http://localhost:9090/kyc/api',
    BILLING: 'http://localhost:9090/billing',
    TGW: 'http://localhost:9090/cloud-transit-gateway',
    PRIVATE_LINK: 'http://localhost:9090/cloud-resource-link',
    DATABASE: 'http://localhost:9090/cloud-db-service',
    DATABASE_ENDPOINTS: 'http://localhost:9090/cloud-db-endpoints-service',
    METRICS: 'http://localhost:9090/v1'
  }
} as const;
